import React from "react"
import ContentfulReachContent from "../components/Global/ContentfulReachContent"

const FAQList = ({ faqQL, lang }) => (
  <section className="faq py-5">
    <div
      className="container"
      itemScope={true}
      itemType="https://schema.org/FAQPage"
    >
      <div className="title2 text-uppercase pb-5">
        {lang === "ru" ? "Популярные вопросы" : "Популярні запитання"}
      </div>
      { faqQL ? (
        faqQL.map(faq => (
          <span
            key={faq.id}
            itemScope={true}
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
          >
            <h2 className="pt-4 pb-3 faq-question" itemProp="name">
              {faq.faqQuestion.internal.content}
            </h2>
            <span
              itemScope={true}
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              <span itemProp="text" className="faq-answer-text">
                <ContentfulReachContent
                  contentJSON={faq.childContentfulFaqFaqAnswerRichTextNode.json}
                />
              </span>
            </span>
          </span>
        ))
      ): ``}
    </div>
  </section>
)

export default FAQList
